module.exports = __webpack_public_path__ + "public/img/milk.4fd5c5c5.png";